import { ReactNode, useState } from "react";
import { Collapse } from "reactstrap";
import { Popover, Whisper } from "rsuite";
import IconButton from "../../../elements/IconButton";

interface Props {
  title: string;
  children: ReactNode;
  optionMenu?: any;
  onDelete?: () => void;
  className?: string;
  style?: any;
  defaultOpen?: boolean;
}

const CollapseItem = ({
  title,
  children,
  optionMenu,
  onDelete,
  className = "my-1",
  style,
  defaultOpen = true,
}: Props) => {
  const [open, setOpen] = useState(defaultOpen);

  if (!title || !children) return null;

  return (
    <div>
      <div
        className={`tw:flex tw:justify-between tw:items-center tw:bg-superlight ${className}`}
        style={{ borderRadius: "4px 4px 0px 0px" }}
      >
        <div
          className="d-flex align-items-center cursor-pointer no-select w-100"
          onClick={() => setOpen(!open)}
        >
          <i
            className={open ? "mdi mdi-chevron-down" : "mdi mdi-chevron-right"}
            style={{ fontSize: "20px", margin: "10px" }}
          />
          <h5 className="m-0">{title}</h5>
          {onDelete && (
            <IconButton
              icon="close"
              tooltipText="Delete Quick Create"
              onClick={onDelete}
              color="danger"
              className="ml-auto mr-2"
            />
          )}
        </div>
        {optionMenu && (
          <Whisper
            placement="auto"
            trigger="click"
            speaker={
              <Popover className="sidebar-popover">{optionMenu}</Popover>
            }
          >
            <i
              className={"mdi mdi-dots-horizontal ml-auto cursor-pointer"}
              style={{ fontSize: "20px", margin: "10px" }}
            />
          </Whisper>
        )}
      </div>
      <Collapse isOpen={open}>
        <div className="d-flex flex-column p-2" style={{ ...style }}>
          {children}
        </div>
      </Collapse>
    </div>
  );
};

export default CollapseItem;
